<template>
  <v-container justify-center>
    <v-stepper v-if="canVote" non-linear v-model="e1">
      <v-stepper-header>
        <v-stepper-step :editable="editable" :complete="e1 > 1" step="1">
          Start
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :editable="editable" :complete="e1 > 2" step="2">
          Director
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :editable="editable" :complete="e1 > 3" step="3">
          Exec Committee
        </v-stepper-step>

        <!-- <v-divider></v-divider>

        <v-stepper-step :editable="editable" :complete="e1 > 3" step="3">
          2nd Vice President
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :editable="editable" :complete="e1 > 4" step="4">
          Treasurer
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :editable="editable" :complete="e1 > 5" step="5">
          Secretary
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :editable="editable" :complete="e1 > 6" step="6">
          Past President
        </v-stepper-step> -->

        <v-divider></v-divider>

        <v-stepper-step :editable="editable" step="4">Summary</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ voteTitle }} Election</div>
              </div>
            </v-card-title>

            <v-card-text>
              Note: {{ voteNote }}<br /><br />
              Directions:
              <ol>
                <li>Click Continue</li>
                <li>Choose up to the max number of candidate(s) for a position</li>
                <li>Click Continue</li>
                <li>On the summary page, make sure your ballot is correct and press Submit to cast your vote</li>
              </ol>
            </v-card-text>

            <p style="color: red;">{{ maxMessage1 }}</p>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 2">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

          <v-stepper-content step="2">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">Director</div>
                <span class="grey--text">
                  (Select up to {{ numberDirectors }})
                </span>
              </div>
            </v-card-title>

            <v-list>
              <v-list-tile v-for="name1 in director" :key="name1.id" avatar>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selected1"
                    :value="name1"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="name1.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <p style="color: red;">{{ maxMessage1 }}</p>

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 1">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 3">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">Exec Committee</div>
                <span class="grey--text">
                  (Select up to {{ numberExecs }})
                </span>
              </div>
            </v-card-title>

            <v-list>
              <v-list-tile v-for="name2 in execComm" :key="name2.id" avatar>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selected2"
                    :value="name2"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="name2.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <p style="color: red;">{{ maxMessage2 }}</p>

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 2">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 4">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <!-- <v-stepper-content step="3">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">2nd Vice President</div>
              </div>
            </v-card-title>

            <v-list>
              <v-list-tile v-for="name3 in secVp" :key="name3.id" avatar>
                <v-list-tile-action>
                  <v-checkbox
                  v-model="selected3"
                    :value="name3"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="name3.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <p style="color: red;">{{ maxMessage3 }}</p>

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 2">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 4">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">Treasurer</div>
              </div>
            </v-card-title>

            <v-list>
              <v-list-tile v-for="name4 in treasurer" :key="name4.id" avatar>
                <v-list-tile-action>
                  <v-checkbox
                  v-model="selected4"
                    :value="name4"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="name4.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <p style="color: red;">{{ maxMessage4 }}</p>

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 3">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 5">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">Secretary</div>
              </div>
            </v-card-title>

            <v-list>
              <v-list-tile v-for="name5 in secretary" :key="name5.id" avatar>
                <v-list-tile-action>
                  <v-checkbox
                  v-model="selected5"
                    :value="name5"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="name5.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <p style="color: red;">{{ maxMessage5 }}</p>

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 4">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 6">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="6">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title>
              <div>
                <div class="headline">Past President</div>
              </div>
            </v-card-title>

            <v-list>
              <v-list-tile v-for="name6 in pastPres" :key="name6.id" avatar>
                <v-list-tile-action>
                  <v-checkbox
                  v-model="selected6"
                    :value="name6"
                  ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title v-text="name6.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <p style="color: red;">{{ maxMessage6 }}</p>

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 5">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="e1 = 7">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content> -->

        <v-stepper-content step="4">
          <v-card class="mx-auto mb-5" max-width="600">
            <v-card-title primary-title class="headline">Completed Ballot</v-card-title>
            <v-list class="ml-4">
              <v-subheader class="title">Director</v-subheader>
              <v-list-tile v-for="name1 in selected1" :key="name1.id" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="name1.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list class="ml-4">
              <v-subheader class="title">Exec Committee</v-subheader>
              <v-list-tile v-for="name2 in selected2" :key="name2.id" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="name2.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <!-- <v-list class="ml-4">
              <v-subheader class="title">2nd Vice President</v-subheader>
              <v-list-tile v-for="name3 in selected3" :key="name3.id" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="name3.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list class="ml-4">
              <v-subheader class="title">Treasurer</v-subheader>
              <v-list-tile v-for="name4 in selected4" :key="name4.id" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="name4.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list class="ml-4">
              <v-subheader class="title">Secretary</v-subheader>
              <v-list-tile v-for="name5 in selected5" :key="name5.id" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="name5.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-list class="ml-4">
              <v-subheader class="title">Past President</v-subheader>
              <v-list-tile v-for="name6 in selected6" :key="name6.id" avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="name6.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list> -->

            <v-card-actions>
              <v-btn :disabled="!editable" text @click="e1 = 2">Back</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!editable" color="primary" @click="sendBallot()">
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-layout wrap v-else>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <span class="headline">Thank you for voting.</span>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Api from '@/services/Api'

export default {
  data () {
    return {
      e1: 0,
      editable: true,
      selected: [],
      selecteda: [],
      selected1: [],
      selected2: [],
      selected3: [],
      selected4: [],
      selected5: [],
      selected6: [],
      maxSelected1: 3,
      maxSelected2: 1,
      maxSelected3: 1,
      maxSelected4: 1,
      maxSelected5: 1,
      maxSelected6: 1,
      maxMessage1: '',
      maxMessage2: '',
      maxMessage3: '',
      maxMessage4: '',
      maxMessage5: '',
      maxMessage6: '',
      names2: [],
      secVp: [],
      execComm: [],
      director: [],
      pastPres: [],
      secretary: [],
      treasurer: [],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      voteId: 0,
      voteTitle: '',
      voteNote: '',
      numberDirectors: '',
      numberExecs: '',
      publicKey: '',
      canVote: true
    }
  },

  created () {
    this.getElection()
    this.getVoters()
  },

  watch: {
    selected1: function () {
      if (this.selected1.length > this.numberDirectors) {
        this.maxMessage1 =
          'You can only select a maximum of  ' + this.numberDirectors
        this.editable = false
      } else {
        this.maxMessage1 = ''
        this.editable = true
      }
    },
    selected2: function () {
      if (this.selected2.length > this.numberExecs) {
        this.maxMessage2 =
          'You can only select a maximum of ' + this.numberExecs
        this.editable = false
      } else {
        this.maxMessage2 = ''
        this.editable = true
      }
    },
    selected3: function () {
      if (this.selected3.length > this.maxSelected3) {
        this.maxMessage3 =
          'You can only select a maximum of ' + this.maxSelected3
        this.editable = false
      } else {
        this.maxMessage3 = ''
        this.editable = true
      }
    },
    selected4: function () {
      if (this.selected4.length > this.maxSelected4) {
        this.maxMessage4 =
          'You can only select a maximum of ' + this.maxMessage4
        this.editable = false
      } else {
        this.maxMessage4 = ''
        this.editable = true
      }
    },
    selected5: function () {
      if (this.selected5.length > this.maxSelected5) {
        this.maxMessage5 =
          'You can only select a maximum of ' + this.maxMessage5
        this.editable = false
      } else {
        this.maxMessage5 = ''
        this.editable = true
      }
    },
    selected6: function () {
      if (this.selected6.length > this.maxSelected6) {
        this.maxMessage6 =
          'You can only select a maximum of ' + this.maxMessage6
        this.editable = false
      } else {
        this.maxMessage6 = ''
        this.editable = true
      }
    }
  },

  methods: {
    async getElection () {
      try {
        let response = await Api().get('current_vote')
        console.log(response.data)

        this.voteId = response.data.id
        this.voteTitle = response.data.name
        this.publicKey = response.data.publicKey
        this.voteNote = response.data.notes
        this.numberDirectors = response.data.numberDirectors
        this.numberExecs = response.data.numberExecs
        this.names2 = response.data.ElectionCandidates

        for (var i = 0; i < this.names2.length; i++) {
          let candidate = {}
          if (this.names2[i].position === '2nd Vice President') {
            candidate.userId = this.names2[i].userId
            candidate.name = this.names2[i].name
            candidate.position = this.names2[i].position
            this.secVp.push(candidate)
          }

          if (this.names2[i].position === 'Treasurer') {
            candidate.userId = this.names2[i].userId
            candidate.name = this.names2[i].name
            candidate.position = this.names2[i].position
            this.treasurer.push(candidate)
          }

          if (this.names2[i].position === 'Secretary') {
            candidate.userId = this.names2[i].userId
            candidate.name = this.names2[i].name
            candidate.position = this.names2[i].position
            this.secretary.push(candidate)
          }

          if (this.names2[i].position === 'Exec Committee') {
            candidate.userId = this.names2[i].userId
            candidate.name = this.names2[i].name
            candidate.position = this.names2[i].position
            this.execComm.push(candidate)
          }

          if (this.names2[i].position === 'Past President') {
            candidate.userId = this.names2[i].userId
            candidate.name = this.names2[i].name
            candidate.position = this.names2[i].position
            this.pastPres.push(candidate)
          }

          if (this.names2[i].position === 'Director') {
            candidate.userId = this.names2[i].userId
            candidate.name = this.names2[i].name
            candidate.position = this.names2[i].position
            this.director.push(candidate)
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getVoters () {
      try {
        let response = await Api().get('currentelections')
        if (this.$store.state.user.TitleId === 1 || this.$store.state.user.TitleId === 3) {
          let voters = response.data.ElectionVoters
          console.log(voters)

          if (voters.length > 0) {
            const myVote = voters.find(x => x.UserId === this.$store.state.user.id)

            if (typeof myVote !== 'undefined') {
              if (myVote.voteDate) {
                this.$router.push('dashboard')
              }
            }
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async sendBallot () {
      try {
        // this.editable = false

        let body = {}
        this.selected = this.selected1
        this.selecteda = this.selected2
        this.selectedb = this.selected3.concat(this.selected4, this.selected5, this.selected6)
        const vote = Object.assign({}, this.selected)
        const votea = Object.assign({}, this.selecteda)
        const voteb = Object.assign({}, this.selectedb)

        body.vote = vote
        body.votea = votea
        body.voteb = voteb
        body.ElectionMainId = this.voteId
        body.userId = this.$store.state.user.id
        body.publicKey = this.publicKey
        console.log(body)

        const response = await Api().post('cast_vote', body)

        this.canVote = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true

        // this.showElections.push(this.editElection)
        // this.editElection = this.defaultElection
        // this.dialog = false
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Vote.vue